/**
 * @ngdoc controllers
 * @memberof mercury.modules.time.compliance.payrules
 * @name TimeCompliancePayRulesManageCtrl
 */
angular.module('mercury.modules.time.compliance.payrules')
.controller('TimeCompliancePayRulesManageCtrl', ["$scope", "$state", "title", "$stateParams", "PayRules", "ActivatedPackages", "reporttime", "PayRuleConstant", "dialog", function($scope, $state, title, $stateParams, PayRules, ActivatedPackages,
  reporttime, PayRuleConstant, dialog) {
  title.set('Manage Pay Adjustment Package');

  var controllerRedirectList = 'Time.Compliance.PayRulesList';
  $scope.errorMessage = null;
  $scope.selectedPackage = {};
  $scope.schedulePopoverTitle = 'Full Schedule';

  var allStaffConst = 'All staff';
  var oneConditionConst = '1 condition';
  var onlyStaffThatMatchConst = 'Only staff that match ';

  $scope.payCodeLabels = [
    {code: 'PublicHoliday', label: 'Public Holiday'},
    {code: 'Award', label: 'Award'},
    {code: 'Allowance', label: 'Allowance'},
    {code: 'Other', label: 'Other'}
  ];

  $scope.loading = PayRules.getById($stateParams.id);
  $scope.loading.then(function(p) {
    $scope.selectedPackage = p;
  }, function() {
    $scope.errorMessage = 'Failed to find your selected package';
  });

  $scope.goBack = function() {
    window.history.back();
  };

  $scope.nullValidTo = function() {
    $scope.selectedPackage.activation.validTo = null;
    $scope.updateActivation($scope.selectedPackage);
  };
  $scope.nullValidFrom = function() {
    $scope.selectedPackage.activation.validFrom = null;
    $scope.updateActivation($scope.selectedPackage);
  };

  $scope.updateValidFromActivation = function(rulePackage) {
    $scope.updateActivation(rulePackage);
  };

  // add on 1 day so the end is the start of the following day
  $scope.updateValidToActivation = function(rulePackage) {
    var dateSelected = moment(rulePackage.activation.validTo).add(1, 'day').format();
    rulePackage.activation.validTo = dateSelected;
    $scope.updateActivation(rulePackage);
  };

  // call the factory function to make the update call
  $scope.updateActivation = function(rulePackage) {
    $scope.updating = ActivatedPackages.updatePackageActivation(rulePackage.activation);
  };

  removePackage = function(rulePackage) {
    rulePackage.activation.validTo = reporttime.end();
    rulePackage.activation.deletedAt = moment().format();

    $scope.updating = ActivatedPackages.updatePackageActivation(rulePackage.activation);
    $scope.updating.then(function() {
      $state.go(controllerRedirectList);
    }, function() {
      $scope.errorMessage = 'Failed to remove package ' + rulePackage.name;
    });
  };

  /// read the rule conditions to determine how staff members are checked
  $scope.getStaffApplied = function(rule) {
    if (rule.conditions.length === 0) {
      return allStaffConst;
    } else {
      // todo: when we have multiple condition types instead of just EmployeeMatch we will need to review how this is displayed
      var numberOfStaffConditions = rule.conditions[0].payload.matchConditions.length;
      if (numberOfStaffConditions === 1) {
        return onlyStaffThatMatchConst + oneConditionConst;
      }

      var applyType = rule.conditions[0].payload.applyType;
      if (applyType === PayRuleConstant.ApplyType.All) {
        return onlyStaffThatMatchConst + 'all ' + numberOfStaffConditions + ' conditions';
      } else if (applyType === PayRuleConstant.ApplyType.Any) {
        return onlyStaffThatMatchConst + 'any of ' + numberOfStaffConditions + ' conditions';
      } else { // if we do not recognise the type then assume it is all
        return allStaffConst;
      }
    }
  };

  $scope.openRemoveDialog = function(rulePackage) {
    dialog.open({
      templateUrl: 'modules/time/compliance/payrules/removePackageDialog.tpl.html',
      controller: 'TimeCompliancePayRulesRemovePackageDialogCtrl',
      size: 'sm'
    }).then(function(dialogResult) {
      if (dialogResult) {
        removePackage(rulePackage);
      }
    });
  };
}]);
